import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetEventPaymentService {

  constructor(private http: HttpClient) {}

  async GetEventPayment() {
    try { 
      let response = await this.http
        .get(`${appApiResources.getEventPayment}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}